import { useEffect, useState } from "react";
import { ipGet, ipError } from "../api";

export const usePlannerPermissions = () => {
  const [permissions, setPermissions] = useState({ can_edit: false, can_publish: false });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setError("");
    ipGet("/permissions", { signal: controller.signal }).then(setPermissions)
      .catch(e => { if (!controller.signal.aborted) setError(ipError(e, "Could not check your planner permissions.")); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [revision]);
  return { ...permissions, can_edit: !loading && !error && permissions.can_edit, can_publish: !loading && !error && permissions.can_publish, loading, error, retry: () => setRevision(v => v + 1) };
};

export const PlannerPermissionsStatus = ({ permissions }) => <>
  {permissions.loading && <p data-testid="ip-permissions-loading" role="status">Checking planner permissions…</p>}
  <PlannerError message={permissions.error} testId="ip-permissions-error" retry={permissions.retry} />
</>;

export const PlannerError = ({ message, testId = "ip-error", retry }) => message ? (
  <div role="alert" data-testid={testId} style={{ margin: "12px 0", padding: 14, border: "1px solid #fb7185", borderRadius: 6, color: "#fda4af", overflowWrap: "anywhere" }}>
    {message}{retry && <button className="btn btn-secondary" data-testid={`${testId}-retry`} onClick={retry} style={{ marginLeft: 12 }}>Retry</button>}
  </div>
) : null;